export default __webpack_public_path__ + "static/media/WDCM4.0618665f.jpg";